import { useContext, useMemo } from 'react'
import Location from '../../../hooks/Location'
import useAdressMaterials from '../../../hooks/useAdressMaterials'
import formatEuro from '../../../helpers/formatEuro'
import { AdressNavigation } from '../../../StateManagment/AdressNavigation'

const MaterialsUsedCard = () => {
    const adressId = Location()[3]
    const [, setAdressNavigation] = useContext(AdressNavigation)

    const { rows, totals, loading } = useAdressMaterials(adressId || '')

    const { distinctCount, totalQuantity } = useMemo(() => {
        const distinct = new Set()
        let qty = 0
        for (const row of rows) {
            if (row.materialID) distinct.add(row.materialID)
            qty += Number(row.quantity) || 0
        }
        return { distinctCount: distinct.size, totalQuantity: qty }
    }, [rows])

    return (
        <div className="new-dashboard-card">
            <div className="new-dashboard-card-content">
                <h3 className="new-dashboard-card-title">Materialen gebruikt</h3>
                <ul className="adress-dashboard-data-list">
                    <li className="adress-dashboard-data-row">
                        <span className="adress-dashboard-data-label">Verschillende materialen</span>
                        <span className="adress-dashboard-data-value">{distinctCount}</span>
                    </li>
                    <li className="adress-dashboard-data-row">
                        <span className="adress-dashboard-data-label">Totaal aantal</span>
                        <span className="adress-dashboard-data-value">{totalQuantity}</span>
                    </li>
                    <li className="adress-dashboard-data-row">
                        <span className="adress-dashboard-data-label">Gebruikt</span>
                        <span className="adress-dashboard-data-value">
                            {loading ? '—' : formatEuro(totals.used)}
                        </span>
                    </li>
                    <li className="adress-dashboard-data-row">
                        <span className="adress-dashboard-data-label">Gepland</span>
                        <span className="adress-dashboard-data-value">
                            {loading ? '—' : formatEuro(totals.planned)}
                        </span>
                    </li>
                    <li className="adress-dashboard-data-row adress-dashboard-data-grand">
                        <span className="adress-dashboard-data-label">Totaal besteed</span>
                        <span className="adress-dashboard-data-value">
                            {loading ? '—' : formatEuro(totals.combined)}
                        </span>
                    </li>
                </ul>
                <button
                    type="button"
                    className="adress-dashboard-view-all"
                    onClick={() => setAdressNavigation('materials')}
                >
                    Bekijk alle materialen →
                </button>
            </div>
        </div>
    )
}

export default MaterialsUsedCard
